import { styled } from '@mui/material/styles';

// eslint-disable-next-line import/prefer-default-export
export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
  gap: theme.spacing(1),
}));
